import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_STARTER } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'StarterPack',
        name: 'Starter Pack',
        icon: 'fas fa-door-open',
        route: { name: ROUTE_NAME_STARTER.PACK.INDEX }
    }
]);

export default registerRouteForModule(router);
